module.exports = __webpack_public_path__ + "img/vidrio.2ea4e2d9.png";